export default function(spec, scope) {
  return spec && spec.signal ? scope.signalRef(spec.signal)
    : spec === false ? false
    : true;
}



// WEBPACK FOOTER //
// ./~/vega-parser/src/parsers/marks/interactive.js